exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".care-team-tasks--3888iak4rA4Fti6zoBveiJ {\n  box-sizing: border-box;\n  padding: .8125rem .8rem 0 .75rem;\n}\n\n.care-team-tasks--3888iak4rA4Fti6zoBveiJ.care-team-tasks--14jv-8GUAF08AYDqed6eYo {\n  padding-top: 0;\n}\n", ""]);

// exports
exports.locals = {
	"checklistItemsContainer": "care-team-tasks--3888iak4rA4Fti6zoBveiJ",
	"checklistItemsContainer": "care-team-tasks--3888iak4rA4Fti6zoBveiJ",
	"isEmpty": "care-team-tasks--14jv-8GUAF08AYDqed6eYo",
	"isEmpty": "care-team-tasks--14jv-8GUAF08AYDqed6eYo"
};